module.exports = __webpack_public_path__ + "img/startup-info-url.8a85de7b.svg";